import React, { useEffect } from 'react';
import { Marker } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import useFetchMunicipios from '../../hooks/useFetchMunicipios';
import L from 'leaflet';

/**
 * Exibe marcadores de municípios em clusters. Marcadores só aparecem em zoom >= fetchThreshold e dentro dos bounds.
 */
const MunicipalityLayer = ({ fetchThreshold = 11, bounds, zoomLevel }) => {
  //console.log('MunicipalityLayer props', { fetchThreshold, zoomLevel, bounds });
  const zoom = zoomLevel;
  const { municipios, loading, error } = useFetchMunicipios(bounds, zoom, fetchThreshold);

  const parseCoord = (v) => {
    if (typeof v === 'string') {
      const clean = v.replace(/[()]/g, '').replace(',', '.').trim();
      return parseFloat(clean);
    }
    return v;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const items = Array.isArray(municipios) ? municipios : municipios?.data || [];
  const validItems = items.filter((m) => {
    const rawLat = m.centroid?.[1] ?? m.latitude ?? m.lat;
    const rawLng = m.centroid?.[0] ?? m.longitude ?? m.lng;
    const lat = parseCoord(rawLat);
    const lng = parseCoord(rawLng);
    return Number.isFinite(lat) && Number.isFinite(lng);
  });
  const visibleItems = validItems.filter((m) => {
    const rawLat = m.centroid?.[1] ?? m.latitude ?? m.lat;
    const rawLng = m.centroid?.[0] ?? m.longitude ?? m.lng;
    const lat = parseCoord(rawLat);
    const lng = parseCoord(rawLng);
    // Converte coords em LatLng para checar corretamente nos bounds
    return bounds?.contains(L.latLng(lat, lng));
  });

  useEffect(() => {
    // console.log('MunicipalityLayer debug:', { fetchThreshold, zoom, bounds, loading, error, items, visibleCount: visibleItems.length });
  }, [fetchThreshold, zoom, bounds, loading, error, items, visibleItems.length]);

  // Mesmo antes do threshold ou sem bounds, renderiza um cluster vazio para registro no LayersControl
  return (
    <MarkerClusterGroup disableClusteringAtZoom={fetchThreshold}>
      {visibleItems.map((m) => {
        const rawLat = m.centroid?.[1] ?? m.latitude ?? m.lat;
        const rawLng = m.centroid?.[0] ?? m.longitude ?? m.lng;
        const lat = parseCoord(rawLat);
        const lng = parseCoord(rawLng);
        const key = m.id ?? m.codigo ?? m.geocodigo ?? `${lat}-${lng}`;
        const label =
          m.municipio ?? m.nome ?? m.name ?? m.properties?.nome ?? m.properties?.NM_MUNICIPIO ?? '';
        // ícone de texto permanente para nome do município
        const icon = L.divIcon({
          className: 'municipio-label',
          html: `<span style="white-space:nowrap;padding:1px 1px;color:#a9ada6;border-radius:2px;">${label}</span>`,
        });
        return <Marker key={key} position={[lat, lng]} icon={icon} />;
      })}
    </MarkerClusterGroup>
  );
};

export default MunicipalityLayer;
